/**
 * Created by mykurisu on 2017/11/21.
 */
import React from 'react'
import {connect} from 'react-redux'
import '../../css/wkCommon.css'
import classnames from 'classnames'


class WKOwnDialog extends React.Component {
    render() {
        const {title, buttons, children, show} = this.props;

        //兼容低版本ios系统不兼容flexbox的情况
        let userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.match(/cpu iphone os (.*?) like mac os/)) {
            let machineVersion = userAgent.match(/cpu iphone os (.*?) like mac os/)[1].split('_')[0];
            if (machineVersion < 8 && /classroom/.test(window.location.pathname)){
                return null
            }
        }

        if (!this.props.show){
            return null
        }

        return (
            <div className="wk__own__dialog" style={{display: show ? 'block' : 'none'}}>
                <div className="dialog__mask" onClick={this.props.buttons ? null : () => this.props.onRequestClose() || null}>
                    <div className="dialog__area">
                        <div className="area__title">
                            {title}
                        </div>
                        <div className="area__content">
                            {children}
                        </div>
                        {buttons &&
                        <div className="area__btn">
                            {buttons.map((item, index) => {
                                return (
                                    <div className={classnames("btn__item",`btn__item_${item.type}`)} key={index}
                                         style={{color: item.type === 'default' ? '#666666' : '#0BB20C'}}
                                         onClick={() => item.onClick()}>
                                        {item.label}
                                    </div>
                                )
                            })}
                        </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}


export default connect()(WKOwnDialog)



// WEBPACK FOOTER //
// ./src/components/wk/WKOwnDialog.js